import React from 'react';
import { iconForGroup, groupForFile } from '../helpers/FileHelpers';

export default class FileNav extends React.PureComponent {
  render() {
    return (<span className="file-nav">
      <span className="file-nav-icon">{iconForGroup(this.props.icon)}</span>
      <span className="file-nav-category">{this.props.category}</span>
      <span className="file-nav-size hidden-sm-down">{this.props.size}</span>
    </span>);
  }
}
